import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isCTP = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'ctp';
